import { SearchField, InputProps } from '@my/ui'

interface ChatSearchProps {
  query: string
  onSearchChange: (value: string) => void
  inputProps?: InputProps
}

export const ChatSearch = ({
  query,
  onSearchChange,
  inputProps,
  ...props
}: ChatSearchProps & InputProps) => {
  return (
    <SearchField
      value={query}
      onSearchChange={onSearchChange}
      w="100%"
      inputProps={{
        h: '$3',
        py: '$2',
        pr: '$11',
        boc: '$overlay4',
        placeholder: 'Search by Username',
        ...props,
      }}
    />
  )
}
